module.exports = __webpack_public_path__ + "svgs/Flat.2a6f4d4731cd22033ea7bf03b2a2728c.svg";